var map = {
	"./arkea.png": 1009,
	"./banque_pop.jpg": 1010,
	"./banque_postale.png": 1011,
	"./bnp.png": 1012,
	"./boursorama.png": 1013,
	"./ca.png": 1014,
	"./caisse_epargne.png": 1015,
	"./cic.jpg": 1016,
	"./credit_mutuel.jpg": 1017,
	"./hellobank.png": 1018,
	"./lcl.png": 1019,
	"./other.png": 1020,
	"./soge.png": 1021
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2947;


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/images/logo/bank/square ^\.\/.*$
// module id = 2947
// module chunks = 2